import ServiceSongs from './ServiceSongs';

export default ServiceSongs;
